module.exports = __webpack_public_path__ + "static/media/banner.ceabb0bc.png";